import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Head } from '@unhead/react';

import { ToastContainer } from '@rewardopl/react-toast';

import colors from '@rewardopl/styles/colors';

import { GlobalStyle } from './root.styles';

import AuthGate from './auth_gate';
import ErrorBoundary from './error_boundary';
import OnlineMonitor from './online_monitor';
import AuthCallback from './pages/auth/callback';
import DashboardPage from './pages/dashboard';
import ErrorPage from './pages/error';
import LoginPage from './pages/login';
import OfflinePage from './pages/offline';
import OnboardingPage from './pages/onboarding';
import PasswordResetPage from './pages/password_reset';
import PasswordResetConfirmationPage from './pages/password_reset_confirmation';
import RegisterPage from './pages/register';
import UnlockPage from './pages/unlock';
import VerifyPage from './pages/verify';
import SplashScreen from './splash_screen';

import { isLoggedIn, isLoggedOut } from '../helpers/authorization';

import { SHOULD_DISABLE_REGISTER_PAGE } from '../constants';

export default function Root() {
  return (
    <>
      <GlobalStyle />
      <Head>
        <meta content={colors.background} name="theme-color" />
      </Head>
      <ToastContainer position="top-right" />
      <ErrorBoundary fallback={<ErrorPage />}>
        <OnlineMonitor fallback={<OfflinePage />}>
          <Suspense fallback={<SplashScreen />}>
            <Routes>
              <Route element={<AuthCallback />} path="auth/*" />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <LoginPage />
                  </AuthGate>
                }
                path="login/*"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <PasswordResetPage />
                  </AuthGate>
                }
                path="password_reset"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <PasswordResetConfirmationPage />
                  </AuthGate>
                }
                path="password_reset_confirmation"
              />
              {SHOULD_DISABLE_REGISTER_PAGE ? null : (
                <Route
                  element={
                    <AuthGate anyOf={isLoggedOut}>
                      <RegisterPage />
                    </AuthGate>
                  }
                  path="register"
                />
              )}
              <Route
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <UnlockPage />
                  </AuthGate>
                }
                path="unlock"
              />
              <Route element={<VerifyPage />} path="verify" />
              <Route
                element={
                  <AuthGate anyOf={isLoggedIn}>
                    <OnboardingPage />
                  </AuthGate>
                }
                path="onboarding/*"
              />
              <Route
                element={
                  <AuthGate anyOf={isLoggedIn}>
                    <DashboardPage />
                  </AuthGate>
                }
                path="*"
              />
            </Routes>
          </Suspense>
        </OnlineMonitor>
      </ErrorBoundary>
    </>
  );
}
